export const IMAGE_BLOCK = 'image-block';
export const TABLE_BLOCK = 'table-block';
